/* eslint-disable */
import React, { useState, useEffect, useRef } from 'react';
import { PropTypes } from 'prop-types';
import { Button, ButtonStyled, Input } from '@nike/nike-design-system-components';

const dedupeFileArray = fileArray =>
  fileArray.filter((file, index, self) => index === self.findIndex(f => f.size === file.size && f.name === file.name));

const FilesDisplayDefault = ({ files, DeleteButtonComponent, deleteFile, DeleteButtonLabel }) => (
  <ul>
    {files.map((file, index) => (
      <li key={`${file.name}${index}`}>
        {file.name}
        <DeleteButtonComponent onClick={() => deleteFile(index)}>{DeleteButtonLabel}</DeleteButtonComponent>
      </li>
    ))}
  </ul>
);

/**
 * TODO: Add file limit, file type filtering, drag and drop?
 */
const FileInput = props => {
  const {
    id,
    name,
    disabled,
    onChange,
    showFiles,
    multiple,
    allowDuplicates,
    DeleteButtonComponent,
    DeleteButtonLabel,
    FileSelectComponent,
    FileSelectLabel,
    fileDisplayComponent: FileDisplayComponent,
    ...rest
  } = props;
  const fileInput = useRef();
  const [filesArray, setFilesArray] = useState([]);

  const handleClick = event => {
    fileInput.current.click();
  };

  const handleChange = event => {
    const {
      target: { files: eventFiles }
    } = event;

    const files = Array.prototype.slice.call(eventFiles);

    if (multiple) {
      const mergedFiles = [...filesArray, ...files];

      setFilesArray(allowDuplicates ? mergedFiles : dedupeFileArray(mergedFiles));
    } else {
      setFilesArray(files);
    }
  };

  const handleDelete = (index, onChange) =>
    setFilesArray([...filesArray.slice(0, index), ...filesArray.slice(index + 1)]);

  // Dispatch the onChange callback when the filesArray changes
  useEffect(() => {
    if (typeof onChange === 'function') onChange(filesArray);
  }, [filesArray, onChange]);

  // If the multiple prop changes while the component has files, set the files array to only contain the first
  useEffect(() => {
    if (!multiple && filesArray.length > 1) setFilesArray([filesArray[0]]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [multiple]);

  // If the allowDuplicates prop changes while the component has duplicates, dedupe the files in the files array
  useEffect(() => {
    if (!allowDuplicates) setFilesArray(dedupeFileArray(filesArray));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allowDuplicates]);

  return (
    <>
      <FileSelectComponent disabled={disabled} onClick={handleClick}>
        {FileSelectLabel}
        <label style={{ display: 'none' }} htmlFor={id}>
          {FileSelectLabel}
          <Input
            id={id}
            name={name}
            type='file'
            value=''
            onChange={handleChange}
            style={{ display: 'none' }}
            ref={fileInput}
            multiple={multiple}
            {...rest}
          />
        </label>
      </FileSelectComponent>
      {
        <FileDisplayComponent
          files={filesArray}
          DeleteButtonComponent={DeleteButtonComponent}
          deleteFile={handleDelete}
          DeleteButtonLabel={DeleteButtonLabel}
        />
      }
    </>
  );
};

FileInput.defaultProps = {
  multiple: false,
  allowDuplicates: false,
  DeleteButtonComponent: Button,
  DeleteButtonLabel: 'Delete',
  FileSelectComponent: Button,
  FileSelectLabel: 'Select File',
  fileDisplayComponent: FilesDisplayDefault,
  showFiles: true,
  disabled: false
};

FileInput.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  multiple: PropTypes.bool,
  disabled: PropTypes.bool,
  allowDuplicates: PropTypes.bool,
  onChange: PropTypes.func,
  DeleteButtonComponent: PropTypes.elementType,
  DeleteButtonLabel: PropTypes.node,
  fileDisplayComponent: PropTypes.elementType,
  FileSelectComponent: PropTypes.elementType,
  FileSelectLabel: PropTypes.node,
  showFiles: PropTypes.bool
};

const FileInputStyled = props => {
  return <FileInput FileSelectComponent={ButtonStyled} DeleteButtonComponent={ButtonStyled} {...props} />;
};

FileInputStyled.propTypes = FileInput.propTypes;

export default FileInputStyled;

export { FileInput, FileInputStyled };
